function initMap(mapa) {
	mapa = mapa || null;
	var styledMapType = new google.maps.StyledMapType(
		[
			{
				"featureType": "all",
				"elementType": "labels.text.fill",
				"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#000000"
						},
						{
							"lightness": 40
						}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.text.stroke",
				"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#000000"
						},
						{
							"lightness": 16
						}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.icon",
				"stylers": [
						{
							"visibility": "off"
						}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.fill",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 20
						}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 20
						}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 21
						}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 18
						}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 16
						}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 19
						}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						}
				]
			}
		], {name: 'Styled Map'});
	var aba = {lat: 48.8754464, lng: 2.3667929};
	var map = new google.maps.Map(document.getElementById('map'), {
		center: aba,
		disableDefaultUI: true,
		zoom: 14.5
	});

	if($(window).outerWidth() < 1200 && $(window).outerWidth() >= 1024) {
		map.zoom = 13.5;
	} else if($(window).outerWidth() < 1024 && $(window).outerWidth() >= 768) {
		map.zoom = 13;
	} else {
		map.zoom = 14;
	}

	$(window).resize(function() {
		if($(window).outerWidth() < 1200 && $(window).outerWidth() >= 1024) {
			map.zoom = 13.5;
		} else if($(window).outerWidth() < 1024 && $(window).outerWidth() >= 768) {
			map.zoom = 13;
		} else {
			map.zoom = 14;
		}
	});

	var iconBase = '../wp-content/themes/aba/assets/img/';
	var icons = {
		aba: {
			icon: iconBase + 'marker.png'
		},
		others: {
			icon: iconBase + 'checked.png'
		}
	};

	var features = [
		{
			position: new google.maps.LatLng(48.875485, 2.369040),
			title: 'Paris',
			type: 'aba'
		}, {
			position: new google.maps.LatLng(47.409719, 1.055671),
			title: 'Saint Règle',
			type: 'aba'
		}
	];

	var i = 0;
	features.forEach(function(feature) {
		//console.log(feature);
		var marker = new google.maps.Marker({
		  position: feature.position,
		  icon: icons[feature.type].icon,
		  map: map,
		  title: feature.title
		});

		marker.addListener('mouseover', function() {
			switch (marker.title) {
				case 'Paris':
					hoverIn($('#paris'));
				break;
				case 'Saint Règle':
					hoverIn($('#saint-regle'));
				break;
			}
		});
		marker.addListener('mouseout', function() {
			switch (marker.title) {
				case 'Paris':
					hoverOut($('#paris'));
				break;
				case 'Saint Règle':
					hoverOut($('#saint-regle'));
				break;
			}
		});
		i++;
	});

	map.mapTypes.set('styled_map', styledMapType);
	map.setMapTypeId('styled_map');
	if(mapa != null) {
		if(mapa == 'paris') {
			map.setCenter(new google.maps.LatLng(48.875485, 2.369040));
		} else if(mapa == 'saint-regle') {
			map.setCenter(new google.maps.LatLng(47.409719, 1.055671));
		}
	}
}